import { render, staticRenderFns } from "./WelcomeCard.vue?vue&type=template&id=54be6a12&scoped=true"
import script from "./WelcomeCard.vue?vue&type=script&lang=js"
export * from "./WelcomeCard.vue?vue&type=script&lang=js"
import style0 from "./WelcomeCard.vue?vue&type=style&index=0&id=54be6a12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54be6a12",
  null
  
)

export default component.exports